import { useTranslation } from "react-i18next";
import { SnackbarMessageStatus, useSnackbarMessages } from "../yoello-lib/modules/components/snackbar/SnackbarContext";

const useSendSnackbar = () => {
    const { t } = useTranslation();
    const { sendSnackbarMessage } = useSnackbarMessages()!;

    const sendSnackbar = (translationKey: string, level: SnackbarMessageStatus) => {
        sendSnackbarMessage(t(translationKey), level);
    }
    return {
        sendSnackbar
    }
}

export default useSendSnackbar;
